<template>
  <div class="contenedor">
    <div class="row">
      <div class="col-12">
        <div class="row mb-2">
          <div
            class="col-12"
            v-if="currentUser.role_id !== '4' && clientId == null"
          >
            <span
              :class="tab == 2 ? 'active border-bottom-3 border-primary' : ''"
              class="p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent"
              @click="changeThisTab(2)"
              v-if="hasPermissions('superAdmin')"
            >
              <i class="icon-flag-checkered"></i>
              {{ $t("lang.label.activity") }}
            </span>
            <span
              :class="tab == 1 ? 'active border-bottom-3 border-primary' : ''"
              class="p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent"
              @click="changeThisTab(1)"
              v-if="hasPermissions('adminClients')"
            >
              <i class="icon-bar-chart"></i> {{ $t("lang.label.agency") }}
            </span>
            <span
              :class="tab == 3 ? 'active border-bottom-3 border-primary' : ''"
              class="p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent"
              @click="changeThisTab(3)"
              v-if="hasPermissions('superAdmin')"
            >
              <i class="icon-clock"></i> Oliver Cronjobs
            </span>
            <span
              :class="tab == 4 ? 'active border-bottom-3 border-primary' : ''"
              class="p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent"
              @click="changeThisTab(4)"
              v-if="hasPermissions('superAdmin')"
            >
              <i class="icon-key"></i> Operational
            </span>
            <span
              :class="tab == 5 ? 'active border-bottom-3 border-primary' : ''"
              class="p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent"
              @click="changeThisTab(5)"
              v-if="hasPermissions('superAdmin')"
            >
              <i class="icon-support"></i> Technical
            </span>
            <span
              :class="tab == 6 ? 'active border-bottom-3 border-primary' : ''"
              class="p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent"
              @click="changeThisTab(6)"
              v-if="hasPermissions('superAdmin')"
            >
              <i class="icon-euro"></i> Commercial
            </span>
            <span
              v-if="hasPermissions('superAdmin')"
              :class="tab == 7 ? 'active border-bottom-3 border-primary' : ''"
              class="p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent"
              @click="changeThisTab(7)"
            >
              <i class="icon-exchange"></i> OWarm
            </span>
            <span

              v-if="hasPermissions('superAdmin')"
              :class="tab == 8 ? 'active border-bottom-3 border-primary' : ''"
              class="p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent"
              @click="changeThisTab(8)"
            >
              <i class="icon-circle-o-notch"></i> Absent Meetings
            </span>
            <span

              v-if="hasPermissions('agencyAccountManager')"
              :class="tab == 9 ? 'active border-bottom-3 border-primary' : ''"
              class="p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent"
              @click="changeThisTab(9)"
            >
              <i class="icon-refresh"></i> Sync Emails
            </span>
          </div>
        </div>

        <div class="row" v-if="tab == 1">
          <div class="col-md-2">
            <date-picker
              id="startDatePicker"
              class=""
              v-model="range.startDate"
              :config="datePickerConfig"
              placeholder="Start Date"
            ></date-picker>
          </div>
          <div class="col-md-2">
            <date-picker
              id="endDatePicker"
              class=""
              v-model="range.endDate"
              :config="datePickerConfigEndDate"
              placeholder="End Date"
            ></date-picker>
          </div>
          <div
            class="col-md-2"
            v-if="currentUser.role_id !== '4' && clientId == null"
          >
            <select v-model="client" class="form-control">
             <option value="false" selected>
                        {{ $t("lang.button.all") }}
                </option>
              <option v-for="team in groups" :value="team.id">
                {{ team.name }}
              </option>
            </select>
          </div>

          <div class="col-md-3">
            <treeselect v-model="filters" :options="optselect" :multiple="true">
            </treeselect>
          </div>

          <div class="col-md-3" v-if="tab == 1">
            <button
              class="btn btn-success w-100"
              :disabled="loadingStats"
              @click="loadRangeStats()"
            >
              <i class="icon-calendar-check-o mr-2"></i>
              <small>
                {{ $t("lang.label.letsgetstarted") }}
              </small>
            </button>
          </div>
        </div>

        <div class="mt-3" v-if="tab == 1 && openchart">
          <button
            class="btn btn-outline-primary"
            :class="timechart == 'day' ? 'active' : ''"
            @click="changeChart('day')"
          >
            <small>
              {{ $t("lang.label.days") }}
            </small>
          </button>
          <button
            class="btn btn-outline-primary ml-2"
            :class="timechart == 'week' ? 'active' : ''"
            @click="changeChart('week')"
          >
            <small>
              {{ $t("lang.label.weeks") }}
            </small>
          </button>
          <button
            class="btn btn-outline-primary ml-2"
            :class="timechart == 'month' ? 'active' : ''"
            @click="changeChart('month')"
          >
            <small>
              {{ $t("lang.label.months") }}
            </small>
          </button>
          <LoadingSpinner v-if="loadingStats" />

          <div v-if="!loadingStats" style="overflow:scroll">
            <div class="row" v-if="false">
              <div class="col-12">
                <line-chart
                  :class="timechart == 'day' ? 'd-block' : 'd-none'"
                  :width="300"
                  :height="400"
                  :chart-data="groupedmeetigns"
                  :options="groupedmeetigns.options"
                />

                <line-chart
                  v-if="timechart == 'week'"
                  :width="300"
                  :height="400"
                  :chart-data="groupedmeetignsweek"
                  :options="groupedmeetignsweek.options"
                />

                <line-chart
                  v-if="timechart == 'month'"
                  :width="300"
                  :height="400"
                  :chart-data="groupedmeetignsmonth"
                  :options="groupedmeetignsmonth.options"
                />
              </div>
            </div>

          <div style="min-width:800px;">
            <line-chart
              :class="timechart == 'week' ? 'd-block' : 'd-none'"
              v-if="multiaxisweek.datasets.length > 0"
              :width="300"
              :height="100"
              :chart-data="multiaxisweek"
              :options="multiaxisweek.options"
            />
            <line-chart
              :class="timechart == 'day' ? 'd-block' : 'd-none'"
              v-if="multiaxis.datasets.length > 0"
              :width="300"
              :height="100"
              :chart-data="multiaxis"
              :options="multiaxis.options"
            />
            <line-chart
              :class="timechart == 'month' ? 'd-block' : 'd-none'"
              v-if="multiaxismonth.datasets.length > 0"
              :width="300"
              :height="100"
              :chart-data="multiaxismonth"
              :options="multiaxismonth.options"
            />
            </div>
          </div>
        </div>

        <div v-if="tab == 1 && hasPermissions('superAdmin')">
          <button class="btn btn-success mt-2" @click="loadAgencyStats()">
            <i class="icon-list mr-2"></i>
            <small> List </small>
          </button>
        </div>

        <div v-if="tab == 1 && hasPermissions('superAdmin')">
          <button class="btn btn-success mt-2" @click="loadRappelActivity()">
            <i class="icon-phone mr-2"></i>
            <small> Rappel History </small>
          </button>
        </div>

        <div class="card no-border mt-3" v-if="tab == 1 && openrappellist">
          <table class="mt-2 ml-2">
            <thead>
              <tr>
                <td>Opportunity</td>
                <td>Quantity</td>
                <td>Status</td>
                <td>Tags</td>
                <td>Last status update</td>
              </tr>
            </thead>
            <tr v-for="rappel in rappellist" class="bg-light border-top">
              <td>
                <strong
                  ><a
                    class="text-primary ml-2 ml-2"
                    target="_blank"
                    :href="'/opportunities/' + rappel.link_id"
                    >Opportunity</a
                  ></strong
                >
              </td>
              <td>{{ rappel.cant }}</td>
              <td>
                <span :class="getClass(rappel)">{{ getText(rappel) }}</span>
              </td>
              <td>{{ rappel.link_tag }}</td>
              <td>{{ rappel.creation_date }}</td>
            </tr>
          </table>
        </div>

        <div class="card no-border mt-3" v-if="tab == 1 && openlist">
          <div class="p-3">
            <strong>Total =</strong> {{ meetings_details.length }}<br />
            <strong>Total Valid Op. =</strong>
            {{ getTotalStatus(meetings_details, 24) }}<br />
            <strong>Total Canceled Op. =</strong>
            {{ getTotalStatus(meetings_details, 34) }}<br />
            <strong>Total Absent Op. =</strong>
            {{ getTotalStatus(meetings_details, 35) }}<br />
            <span :key="totalkey"> </span>
          </div>

          <table class="mt-2 ml-2">
            <thead>
              <tr>
                <td>{{ $t("lang.column.client") }}</td>
                <td>{{ $t("lang.column.campaign") }}</td>
                <td>{{ $t("lang.column.eventdate") }}</td>
                <td>{{ $t("lang.column.opportunityStatus") }}</td>
                <td>{{ $t("lang.label.businesses") }}</td>
              </tr>
            </thead>
            <tr v-for="event in meetings_details" class="bg-light border-top">
              <td>{{ event.client_name }}</td>
              <td>
                {{ event.name }}
                <i
                  class="icon-calendar text-primary cursor-pointer"
                  v-if="calendlyid != event.remark"
                  @click="calendlyid = event.remark"
                ></i>
                <CalendlyEvent
                  :id="event.remark"
                  v-if="calendlyid == event.remark"
                ></CalendlyEvent>
              </td>
              <td>
                <table>
                  <thead>
                    <tr>
                      <th>{{ $t("lang.column.creationdate") }}</th>
                      <th>{{ $t("lang.column.eventdate") }}</th>
                      <th>{{ $t("lang.column.status") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-if="getEventRow(event.event_date)"
                      v-for="ev in getEventRow(event.event_date)"
                    >
                      <td>C {{ getEventDate(ev, 0) }}</td>
                      <td>E {{ getEventDate(ev, 1) }}</td>
                      <td>
                        <span
                          class="badge"
                          :class="getClassBadge(getEventDate(ev, 2))"
                          >{{ getEventDate(ev, 2) }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <strong v-if="event.status == null"
                  ><span class="badge bg-success text-white"
                    >valid</span
                  ></strong
                >
                <strong v-if="event.status == 34"
                  ><span class="badge bg-danger text-white"
                    >canceled</span
                  ></strong
                >
                <strong v-if="event.status == 24"
                  ><span class="badge bg-success text-white"
                    >valid</span
                  ></strong
                >
                <strong v-if="event.status == 35"
                  ><span class="badge bg-warning text-white"
                    >absent</span
                  ></strong
                >
              </td>
              <td>
                <strong
                  ><a
                    class="text-primary ml-2 ml-2"
                    target="_blank"
                    :href="'/opportunities/' + event.link_id"
                    >{{ event.business_name }}</a
                  ></strong
                >
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="col-md-2" v-if="currentUser.role_id !== '4' && tab == 2">
      <select v-model="client" class="form-control" @change="showNow(client)">
        <option v-for="team in groups" :value="team.id">{{ team.name }}</option>
      </select>
    </div>

    <div class="row" v-if="tab == 2 && showteam">
      <div class="card w-100 p-2 my-3">
        <TableMonitor :team_id="showteam" :key="showteam"></TableMonitor>
      </div>
    </div>

    <div v-for="(pos, key) in positions" v-if="pos.tab == tab">
      <div class="row mt-2">
        <Fieldset :title="pos.title" :mykey="key" :open="false">
          <div v-for="not in notif" v-if="showThisItem(pos, not)">
            <small class="text-secondary">{{ not.not_created }} </small>
            <small
              v-if="not.quantity == 1 && not.ref_id == 1"
              class="badge badge-secondary mr-1"
              >{{ not.title }} ({{ not.quantity }})</small
            >
            <small
              v-if="not.quantity == 2 && not.ref_id == 1"
              class="badge badge-warning mr-1"
              >{{ not.title }} ({{ not.quantity }})</small
            >
            <small
              v-if="not.quantity > 2 && not.ref_id == 1"
              class="badge badge-danger mr-1"
              >{{ not.title }} ({{ not.quantity }})</small
            >
            <small
              v-if="not.ref_id == 2"
              class="badge badge-success mr-1 text-white"
            >
              {{ not.title }}</small
            >
            {{ not.message }}
          </div>
        </Fieldset>
      </div>
    </div>

    <div class="row" v-if="tab == 3">
        <div v-if="workspace" class="col-md-3" v-for="(project, key) in workspace" :key="key">
          <div
            @click="openModal('workspace', project.id)"
            class="p-4 bg-light rounded text-center cursor-pointer shadow"
          >
            <h4><i class="icon-group"></i></h4>
            <div class="w-100">
              <span
                >{{ project.email_owner }} <br /><strong>
                  id:{{ project.id }}
                </strong></span
              ><br />
              <span>{{ project.project_id }}</span>
            </div>
          </div>
        </div>
        </div>
    <div class="row mt-4" v-if="tab == 3">
      <div class="col-md-3">
        <div
          @click="openModal('pending')"
          class="p-4 bg-light rounded text-center cursor-pointer shadow"
        >
          <h4><i class="icon-clock"></i></h4>
          <p>Pending Domains</p>
        </div>
      </div>

      <div class="col-md-3">
        <div class="text-center p-2 card shadow bg-light" v-if="tab == 3">
          <div class="content">
            <p class="ml-2 mt-2 mb-2">Actives Nylas accounts</p>
            <h3>{{ activenylas }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div
          @click="openModal('emailsqueue')"
          class="p-4 bg-light rounded text-center cursor-pointer shadow"
        >
          <h4><i class="icon-list"></i></h4>
          <p>Emails Queue</p>
        </div>
      </div>
    </div>
    <modal
      name="workspace"
      :clickToClose="true"
      :resizable="true"
      :scrollwheel="true"
      height="400px"
      width="80%"
      class="p-3">
      <div class="row" v-if="workspacedomains">
        <div class="col-6  mb-3" v-for="(domain, key) in workspacedomains" :key="key">
        <Checkhttps :domain="domain.domain"></Checkhttps>
              <span v-if="domain.dkim == 'TXT'" class="d-inline ml-2 text-success">
                <strong>DKIM</strong><i class="icon-checkmark"></i>
              </span>
              <span v-if="domain.dkim == null" class="d-inline ml-2 text-danger">
                <strong>DKIM</strong><i class="icon-close"></i>
              </span>
        <Fieldset :title="domain.domain" :mykey="key" @opennow="openDomain(domain.id)">
          {{domain.name}}
          <div
          v-if="workspaceusers"
          v-for="domain in workspaceusers"
        >
          <div class="card m-2 p-2 shadow" @click="openModal('domain', domain.workspace_id)">
            <span> {{ domain.email }}</span>
          </div>
        </div>
        </Fieldset>
        </div>
      </div>
    </modal>
    <modal
      name="emailsqueue"
      :clickToClose="true"
      :scrollwheel="true"
      height="600px"
      width="50%"
      class="p-3"
    >
      <div class="row m-2">
        <span class="mx-2 badge badge-secondary">1: Waiting</span>
        <span class="mx-2 badge badge-primary">2: Processing</span>
        <span class="mx-2 badge badge-success text-white">3: Sent</span>
        <span class="mx-2 badge badge-danger">4: Canceled</span>
        <span class="mx-2 badge badge-primary">5: Pre-process replace</span>
        <span class="mx-2 badge badge-primary">6: Post-process repace</span>
        <span class="mx-2 badge badge-danger"
          >7: Could not verify access credential</span
        >
      </div>
      <div class="row px-4">
        <Table
          v-if="emailsqueue.length > 0"
          :headers="emailsqueueHeader"
          :cols="emailsqueueCols"
          :data="emailsqueue"
          :checkbox="false"
          :notselect="true"
          :model="model"
        >
        </Table>
      </div>
    </modal>

    <modal
      name="pending"
      :clickToClose="true"
      :resizable="true"
      :scrollwheel="true"
      height="auto"
      width="80%"
      class="p-3"
    >
      <div class="row" v-if="pendingdomains">
        <div class="col-2" v-for="(domain, key) in pendingdomains" :key="key">
          <div
            class="card m-2 p-2 shadow"
            @click="openModal('domain', domain.id)"
          >
            <span>
              {{ domain.domain }} <strong>({{ domain.name }})</strong></span
            >
          </div>
        </div>
      </div>
    </modal>


    <div class="mt-3" v-if="tab == 7">
      <OwarmStats :groups="groups" />
    </div>

    <div>
      <div class="col-md-12" v-if="tab == 8">
        <h3>Absent Links</h3>
        <div class="card scrollable">
          <Table
            v-if="absentLinks.length > 0"
            :headers="absentLinksHeaders"
            :cols="absentLinksCols"
            :data="absentLinks"
            :checkbox="false"
            :notselect="true"
            :model="model"
            @goToOpportunity="goToOpportunity"
          >
          </Table>
        </div>
      </div>
    </div>

    <template v-if="tab == 9">
        <EmailSyncList />
    </template>


    <div class="row" v-if="false">
      <div class="col-md-6">
        <h3>Active Campaigns</h3>
        <div class="scrollable">
          <div
            class="row m-2 border"
            v-for="(campaign, key) in activecampaigns"
          >
            <div class="col-6">
              <li>Campaign Name: {{ campaign.name }}</li>
              <li>Client: {{ campaign.clientname }}</li>
            </div>
            <div class="col-6"></div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <h3>Last Users</h3>
        <div class="card scrollable">
          <Table
            v-if="lastusers.length > 0"
            :key="keytable"
            :headers="headers"
            :cols="cols"
            :data="lastusers"
            :checkbox="false"
            :model="model"
          >
          </Table>
        </div>
      </div>

      <div class="col-md-12 mt-3">
        <h3>Gmaps Imports</h3>
        <button class="btn btn-sm btn-primary" @click="refreshgmail()">
          <i class="icon-refresh"></i>
        </button>
        <div class="card scrollable p-2">
          <Table
            v-if="gmaillist.length > 0 && !loadinggmail"
            :key="keygmail"
            :headers="headers3"
            :cols="cols3"
            :data="gmaillist"
            :checkbox="false"
            :model="model"
          >
          </Table>
          <span
            v-if="loadinggmail"
            class="loadingres mr-2 ml-2 spinner-border loading-spinner"
          ></span>
        </div>
      </div>

      <div class="col-md-12 mt-3">
        <h3>Linkedin Imports</h3>
        <button class="btn btn-sm btn-primary" @click="refreshlinkedin()">
          <i class="icon-refresh"></i>
        </button>
        <div class="card scrollable p-2">
          <Table
            v-if="linkedinlist.length > 0 && !loadinglinkedin"
            :key="keygmail"
            :headers="headers4"
            :cols="cols4"
            :data="linkedinlist"
            :checkbox="false"
            :model="model"
          >
          </Table>
          <span
            v-if="loadinglinkedin"
            class="loadingres mr-2 ml-2 spinner-border loading-spinner"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  statusBadgeMixin,
  statusPointMixin,
  statusFeedNotificationsMixin,
  formattersMixin,
} from "@/_mixins/";
import Table from "@/components/Common/Table.vue";

import TableMonitor from "@/components/Dashboard/Monitor/Table.vue";
import ContactsAvailable from "@/components/Campaigns/ContactsAvailable.vue";
import CalendlyEvent from "@/components/Common/CalendlyEvent.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import Checkhttps from "@/components/Common/Checkhttps.vue";
import { mapState, mapActions } from "vuex";
import { router } from "@/_helpers";
import moment from "moment";
import LineChart from "@/components/Chart.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Tutorial from "@/components/Tutorial.vue";
import {
  adminService,
  monitorService,
  campaignsService,
  workspaceService,
  usersService,
  opportunitiesService,
} from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import DashboardStatistics from "@/components/Campaigns/DashboardStatistics.vue";
import OwarmStats from "@/components/Owarm/OwarmStats.vue";
import EmailSyncList from "@/components/Agencies/EmailSyncList.vue";

export default {
  props: {
    clientId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      openrappellist: false,
      activenylas: [],
      showteam: false,
      workspace: false,
      workspacedomains: false,
      workspaceusers: false,
      pendingdomains: false,
      emailsqueue: false,
      emailsqueueCols: [
        [
          {
            value: "email_from",
          },
        ],
        [
          {
            value: "email_to",
          },
        ],
        [
          {
            value: "created",
          },
        ],
        [
          {
            value: "updated",
          },
        ],
        [
          {
            value: "campaign_step_queue_status_id",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-secondary",
              },
              {
                icon_if_value: "2",
                icon_true: "icon-refresh text-primary",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-checkmark text-success",
              },
              {
                icon_if_value: "4",
                icon_true: "icon-stop text-danger",
              },
              {
                icon_if_value: "5",
                icon_true: "icon-arrow-left text-primary",
              },
              {
                icon_if_value: "6",
                icon_true: "icon-arrow-right text-primary",
              },
              {
                icon_if_value: "7",
                icon_true: "icon-close text-danger",
              },
            ],
          },
        ],
        [
          {
            value: "name",
          },
        ],
      ],
      emailsqueueHeader: [
        {
          label: this.$t("lang.column.from"),
        },
        {
          label: this.$t("lang.label.to"),
        },
        {
          label: this.$t("lang.label.created"),
        },
        {
          label: "Updated",
        },
        {
          label: this.$t("lang.label.status"),
        },
        {
          label: this.$t("lang.label.client"),
        },
      ],
      positions: [
        {
          title: "Gmail Workspace",
          tab: 4,
          type: "workspace",
        },
        {
          title: "Gmail Workspace",
          tab: 5,
          type: "workspacecom",
        },
        {
          title: "Campaigns",
          tab: 4,
          type: "campaigns",
        },
        {
          title: "Campaigns",
          tab: 5,
          type: "campaignsupporterror",
        },
        {
          title: "Workflows",
          tab: 4,
          type: "workflows",
        },
        {
          title: "Payments",
          tab: 6,
          type: "payments",
        },
        {
          title: "Contracts",
          tab: 6,
          type: "contracts",
        },
      ],
      notif: [],
      rappellist: [],
      googleusers: [],
      absentLinks: [],
      openlist: false,
      totalkey: 0,
      client: false,
      filters: [],
      value: null,
      optselect: [],
      options: [
        {
          id: "sent",
          label: "Sent, Bounces",
          role: ["1","5","6"],
          isDisabled: false,
          color: "255,0,100",
        },
        {
          id: "newsent",
          label: "New Sent",
          role: ["1","5","6"],
          isDisabled: false,
          color: "255,100,0",
        },
        {
          id: "recurringsent",
          label: "Recurring Sent",
          role: ["1","5","6"],
          isDisabled: false,
          color: "255,0,0",
        },
        {
          id: "recurringsent2",
          label: "Step 2",
          role: ["1"],
          isDisabled: false,
          color: "180,140,30",
        },
        ,
        {
          id: "recurringsent3",
          label: "Step 3",
          role: ["1"],
          isDisabled: false,
          color: "210,230,20",
        },
        ,
        {
          id: "recurringsent4",
          label: "Step 4",
          role: ["1"],
          isDisabled: false,
          color: "180,200,30",
        },
        ,
        {
          id: "recurringsent5",
          label: "Step 5",
          role: ["1"],
          isDisabled: false,
          color: "180,130,30",
        },
        ,
        {
          id: "recurringsent6",
          label: "Step 6",
          role: ["1"],
          isDisabled: false,
          color: "230,230,120",
        },
        {
          id: "money",
          label: "€€€",
          role: ["1"],
          isDisabled: false,
          color: "43, 199, 0",
        },
        {
          id: "billing",
          label: this.$t("lang.statistics.billing"),
          role: ["1","5","6","7"],
          isDisabled: false,
          color: "28, 4, 219",
        },
        {
          id: "meetings",
          label: this.$t("lang.statistics.generated"),
          role: ["4", "1","5","6","7"],
          isDisabled: false,
          color: "51, 204, 204",
        },
        {
          id: "cashable",
          label: this.$t("lang.statistics.cashable"),
          role: ["1"],
          isDisabled: false,
          color: "86, 225, 219",
        },
        {
          id: "declined",
          label: this.$t("lang.statistics.declined"),
          role: ["1"],
          isDisabled: false,
          color: "250, 46, 195",
        },
        {
          id: "cashed",
          label: this.$t("lang.statistics.cashed"),
          role: ["1"],
          isDisabled: false,
          color: "122, 169, 81",
        },
        {
          id: "opened",
          label: this.$t("lang.statistics.cumulative"),
          role: ["1"],
          isDisabled: false,
          color: "222, 138, 131",
        },
        {
          id: "cumulative",
          label: this.$t("lang.statistics.manhours"),
          role: ["4", "1"],
          isDisabled: false,
          color: "0 ,0 ,255",
        },
        {
          id: "sessions",
          label: this.$t("lang.statistics.session"),
          role: ["1"],
          isDisabled: false,
          color: "45, 138, 131",
        },
        {
          id: "spam",
          label: this.$t("lang.statistics.antispam"),
          role: ["4", "1"],
          isDisabled: false,
          color: "117, 122, 124",
        },
        {
          id: "engaged",
          label: this.$t("lang.statistics.engaged"),
          role: ["1"],
          isDisabled: false,
          color: "248, 251, 48",
        },
        {
          id: "relaunch",
          label: this.$t("lang.statistics.relaunch"),
          role: ["1"],
          isDisabled: false,
          color: "0, 251, 0",
        },
        {
          id: "reprogramming",
          label: this.$t("lang.statistics.reprogramming"),
          role: ["4", "1"],
          isDisabled: false,
          color: "0, 0, 48",
        },
        {
          id: "answers",
          label: this.$t("lang.statistics.spell"),
          role: ["4", "1"],
          isDisabled: false,
          color: "255, 20, 255",
        },
        {
          id: "made",
          label: this.$t("lang.statistics.made"),
          role: ["4", "1"],
          isDisabled: false,
          color: "0,0,0",
        },
      ],
      openchart: false,
      meetings_details: [],
      tab: 1,
      timechart: "day",
      calendlyid: 0,
      opentotals: false,
      lastusers: [],
      totalev: {},
      cols: [],
      groups: [],
      teamgroups: [],
      cantgroups: 2,
      headers: [],
      cols3: [],
      headers3: [],
      cols4: [],
      headers4: [],
      gmaillist: [],
      keytable: 100,
      activecampaigns: [],
      model: {},
      keygmail: 200,
      loadinggmail: false,
      keylinkedin: 200,
      loadinglinkedin: false,
      linkedinlist: [],
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        // minDate: moment().startOf("day")
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      range: {
        startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      groupedmeetignsmonth: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Data One",
            backgroundColor: "#52BE80",
            data: [],
          },
          {
            type: "bar",
            label: "Data Two",
            backgroundColor: "#dc3545",
            data: [],
          },
          {
            type: "bar",
            label: "Data Three",
            backgroundColor: "#ffc107",
            data: [],
          },
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                time: {
                  unit: "month",
                  displayFormats: {
                    month: "M YYYY",
                  },
                },
              },
            ],
            yAxes: [
              {
                type: "linear",
                stacked: true,
                id: "y2",
                min: 0,
                max: 100,
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 100,
                },
              },
            ],
          },
        },
      },
      groupedmeetignsweek: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Data One",
            backgroundColor: "#52BE80",
            data: [],
          },
          {
            type: "bar",
            label: "Data Two",
            backgroundColor: "#dc3545",
            data: [],
          },
          {
            type: "bar",
            label: "Data Three",
            backgroundColor: "#ffc107",
            data: [],
          },
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                time: {
                  unit: "week",
                  displayFormats: {
                    week: "W YYYY",
                  },
                },
              },
            ],
            yAxes: [
              {
                type: "linear",
                stacked: true,
                id: "y2",
                min: 0,
                max: 100,
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 100,
                },
              },
            ],
          },
        },
      },
      groupedmeetigns: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Data One",
            backgroundColor: "#52BE80",
            data: [],
          },
          {
            type: "bar",
            label: "Data Two",
            backgroundColor: "#dc3545",
            data: [],
          },
          {
            type: "bar",
            label: "Data Three",
            backgroundColor: "#ffc107",
            data: [],
          },
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                time: {
                  unit: "day",
                },
              },
            ],
            yAxes: [
              {
                type: "linear",
                stacked: true,
                id: "y2",
                min: 0,
                max: 100,
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 100,
                },
              },
            ],
          },
        },
      },
      multiaxismonth: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Meetings",
            borderColor: "RGB(133,43,242,1)",
            backgroundColor: "RGBA(133,43,242,0.51)",
            pointBackgroundColor: "rgba(220,220,220,1)",
            yAxisID: "y2",
            data: [],
          },
        ],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity"),
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "month",
                },
                stacked: false,
                offset: true,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        },
      },
      multiaxisweek: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: "Meetings",
            borderColor: "RGB(122,43,242,1)",
            backgroundColor: "RGBA(133,23,242,0.51)",
            pointBackgroundColor: "rgba(110,220,220,1)",
            yAxisID: "y2",
            data: [],
          },
        ],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity"),
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "week",
                  displayFormats: {
                    week: "W YYYY",
                  },
                },
                offset: true,
                gridLines: {
                  display: true,
                },
              },
            ],
          },
        },
      },
      multiaxis: {
        labels: [],
        datasets: [],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity"),
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "day",
                },
                stacked: false,
                offset: true,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        },
      },
      absentLinksHeaders: [
        {
          label: this.$t("lang.label.client"),
          size: "130px",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.business"),
          size: "130px",
          class: "overflowhide",
        },
      ],
      absentLinksCols: [
        [
          {
            value_label: "business_name",
            value_emit: "link_id",
            class: "text-primary",
            type: "emit",
            emit: "goToOpportunity",
          },
        ],
        [
          {
            value: "client_name",
          },
        ],
      ],
    };
  },
  components: {
    LineChart,
    LoadingSpinner,
    DashboardStatistics,
    ContactsAvailable,
    Tutorial,
    Fieldset,
    Table,
    TableMonitor,
    CalendlyEvent,
    Treeselect,
    OwarmStats,
    EmailSyncList,
    Checkhttps
  },

  mixins: [
    statusBadgeMixin,
    statusPointMixin,
    statusFeedNotificationsMixin,
    formattersMixin,
  ],

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    ...mapState({
      loading: (state) => state.campaigns.loading,
      campaigns: (state) => state.campaigns.alldashboard.data,
      currentUser: (state) => state.authentication.user,
      loadingStats: (state) => state.campaigns.loadingStats,
      stats: (state) => state.campaigns.stats.data,
      plans: (state) => state.plans.all,
    }),
    toastNotificationData() {
      return this.$store.state.authentication.toastNotificationData;
    },
  },
  watch: {
    loadingStats: function () {
      this.loadStatsData();
    },
  },

  created() {
    this.cols = [
      [
        {
          value: "creation_date",
        },
      ],
      [
        {
          value: "name",
        },
      ],
      [
        {
          value: "lastname",
        },
      ],
      [
        {
          value: "email",
        },
      ],
    ];
    this.headers = [
      {
        label: this.$t("lang.label.creationdate"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.column.name"),
        size: "80px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.column.lastname"),
        size: "80px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.column.email"),
        size: "100px",
        class: "overflowhide",
      },
    ];

    this.headers3 = [
      {
        label: "id",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.label.name"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.label.status"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Total points",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Processed points",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Business found",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Bussiness processed",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Imported",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.label.industry"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Linkedin",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Created",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Updated",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Time",
        size: "130px",
        class: "overflowhide",
      },
    ];

    this.cols3 = [
      [
        {
          value: "id",
        },
      ],
      [
        {
          value: "name",
        },
      ],
      [
        {
          value: "status",
          icons: [
            {
              icon_if_value: "finished",
              icon_true: "icon-checkmark text-success",
            },
            {
              icon_if_value: "pending",
              icon_true: "icon-clock text-secondary",
            },
            {
              icon_if_value: "paused",
              icon_true: "icon-pause text-warning",
            },
            {
              icon_if_value: "processing",
              icon_true: "icon-download text-primary",
            },
          ],
        },
      ],
      [
        {
          value: "point_total",
        },
      ],
      [
        {
          value: "point_processed",
        },
      ],
      [
        {
          value: "total",
        },
      ],
      [
        {
          value: "finished",
        },
      ],
      [
        {
          value: "imported",
        },
      ],
      [
        {
          value: "industry",
        },
      ],
      [
        {
          value: "searchlinkedin",
        },
      ],
      [
        {
          value: "created",
        },
      ],
      [
        {
          value: "updated",
        },
      ],
      [
        {
          value: "difference",
        },
      ],
    ];
    this.headers4 = [
      {
        label: "id",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.label.name"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: this.$t("lang.label.status"),
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "job_id",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Total",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Processed",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Imported",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Created",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Updated",
        size: "130px",
        class: "overflowhide",
      },
      {
        label: "Time",
        size: "130px",
        class: "overflowhide",
      },
    ];

    this.cols4 = [
      [
        {
          value: "id",
        },
      ],
      [
        {
          value: "name",
        },
      ],
      [
        {
          value: "status",
          icons: [
            {
              icon_if_value: "imported",
              icon_true: "icon-checkmark text-success",
            },
            {
              icon_if_value: "pending",
              icon_true: "icon-clock text-secondary",
            },
            {
              icon_if_value: "importing",
              icon_true: "icon-download text-primary",
            },
          ],
        },
      ],
      [
        {
          value: "job_id",
        },
      ],
      [
        {
          value: "result",
        },
      ],
      [
        {
          value: "processed",
        },
      ],
      [
        {
          value: "imported",
        },
      ],
      [
        {
          value: "created",
        },
      ],
      [
        {
          value: "updated",
        },
      ],
      [
        {
          value: "difference",
        },
      ],
    ];

    let opt = this.options;
    this.options.forEach((r, index) => {
      if (r.role.indexOf(this.currentUser.role_id) >= 0) {
        if (r.isDisabled) {
          r.label = r.label + " (coming soon)";
        }
        this.optselect.push(r);
        if (r.id == "meetings") {
          this.filters.push(r.id);
        }
      }
    });

    this.myTeamList();
  },
  methods: {
    ...mapActions("campaigns", {
      getAllCampaigns: "getInfoCampaigns",
    }),
    ...mapActions("campaigns", {
      getCampaignStatsByIdAndRange: "getStatsByIdAndRange",
    }),
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    hasPermissions(perm){
      return this.$store.getters['authentication/hasPermissions'](perm)
    },
    openModal(type, arg) {
      if (type == "workspace") {
        this.workspacedomains = false;
        workspaceService.getWorkspaceDomains(arg).then((result) => {
          this.workspacedomains = result;
        });
        this.$modal.show(type);
        return;
      }

      if (type == "emailsqueue") {
        this.pendingdomains = false;
        adminService.getEmailsQueue().then((result) => {
          this.emailsqueue = result;
        });
        this.$modal.show(type);
        return;
      }

      if (type == "pending") {
        this.pendingdomains = false;
        workspaceService.getWorkspaceDomains().then((result) => {
          this.pendingdomains = result;
        });
        this.$modal.show(type);
        return;
      }

      if (type == "domain") {
        this.closeModal("workspace");
        this.openDomain(arg)
        this.$modal.show(type);
        return;
      }

      this.$modal.show(type);
    },
    closeModal(type) {
      this.$modal.hide(type);
    },
    showNow(client_id) {
      this.showteam = client_id;
    },
    openDomain(arg){
        this.workspaceusers = false;
        workspaceService.getWorkspaceUsers(arg).then((result) => {
          this.workspaceusers = result;
        });
        return;
    },
    showThisItem(item, not) {
      if (item.type == "workspace") {
        if (
          (not.entity_type == "emailworkspace" && not.ref_id == "2") ||
          (not.entity_type == "buydomain" && not.ref_id == "1")
        ) {
          return true;
        }
      }
      if (item.type == "workspacecom") {
        if (
          not.entity_type == "buydomain" ||
          not.entity_type == "emailworkspace" ||
          not.entity_type == "workspacedomain" ||
          not.entity_type == "dnsdomain"
        ) {
          return true;
        }
      }

      if (item.type == "campaigns") {
        if (not.entity_type == "campaignerror") {
          return true;
        }
      }
      if (item.type == "campaignsupporterror") {
        if (not.entity_type == "campaignsupporterror") {
          return true;
        }
      }
      if (item.type == "workflows") {
        if (not.entity_type == "workflowerror") {
          return true;
        }
      }
      if (item.type == "contracts") {
        if (not.entity_type == "validationdate") {
          return true;
        }
      }
      if (item.type == "payments") {
        if (not.entity_type == "paymenterror") {
          return true;
        }
      }
      return false;
    },
    permissionFront() {
      return (
        (this.currentUser.team_role_id == undefined ||
          this.currentUser.team_role_id != 3) &&
        this.currentUser.role_id != 4
      );
    },
    getClass(opportunity) {
      if (opportunity.link_status_reason_id == 35) {
        return "badge badge-warning";
      }
      if (opportunity.link_status_reason_id == 34) {
        return "badge badge-danger";
      }
      if (opportunity.link_status_reason_id == 24) {
        return "badge badge-success";
      }
      return "";
    },
    getText(opportunity) {
      if (opportunity.link_status_reason_id == 35) {
        return this.$t("lang.refuse.absentlabel");
      }
      if (opportunity.link_status_reason_id == 34) {
        return this.$t("lang.refuse.refused");
      }
      if (opportunity.link_status_reason_id == 24) {
        return this.$t("lang.refuse.valid");
      }
      return "";
    },
    getTotalStatus(list, status) {
      let cant;
      cant = 0;
      list.forEach((r) => {
        if (r.status == status) {
          cant++;
        } else {
          if (!r.status && status == 24) {
            cant++;
          }
        }
      });
      return cant;
    },
    getEventRow(eventdate) {
      if (eventdate == null) {
        return false;
      }
      let ev = eventdate.split(",");
      return ev;
    },
    getEventDate(ev, r) {
      return ev.split("|")[r];
    },
    getClassBadge(status) {
      if (status == "canceled") {
        return "text-white bg-danger";
      }
      if (status == "active") {
        return "text-white bg-success";
      }
    },
    changeThisTab(id) {
      if (id == 3) {
        workspaceService.getWorkspaceAdmins().then((result) => {
          this.workspace = result;
        });

        adminService.getOliverVariables("activenylas").then((result) => {
          this.activenylas = result;
        });
      }
      if (id > 3 && id < 7) {
        usersService.getNotificationsIssues().then((result) => {
          this.notif = result;
        });
      }
      if (id == 8) {
        opportunitiesService.getAbsentMeetingTreatmentLinks().then((result) => {
          this.absentLinks = result;
        });
      }
      if (id == 1 && this.currentUser.role_id !== "1") {
        this.loadRangeStats();
      }

      this.tab = id;
    },
    getTotal() {
      if (this.totalev.length == 0) {
        return false;
      }
      return this.totalev;
    },
    loadRappelActivity() {
      this.total = {};
      this.openlist = false;
      this.opentotals = false;
      campaignsService.getRappelActivity(2771).then((result) => {
        this.rappellist = result;
        this.openrappellist = true;
      });
    },
    loadAgencyStats() {
      this.opentotals = false;
      this.openrappellist = false;
      this.total = {};
      campaignsService
        .getAgencyStatsRange(
          this.range.startDate,
          this.range.endDate,
          this.client
        )
        .then((result) => {
          this.meetings_details = result.activity_by_date;
          this.openlist = true;
        });
    },

    changeChart(type) {
      this.timechart = type;
    },
    loadMultiaxis() {
      this.options.forEach((r, index) => {
        if (this.filters.indexOf(r.id) >= 0) {
          let type = "bar";
          let yaxis = "y2";

          if (r.id == "answers") {
            yaxis = "y1";
          }

          if (r.id == "meetings") {
            type = "line";
            yaxis = "y1";
          }
          if (r.id == "reprogramming") {
            type = "line";
            yaxis = "y1";
          }
          if (
            r.id == "recurringsent" ||
            r.id == "recurringsent2" ||
            r.id == "recurringsent3" ||
            r.id == "recurringsent4" ||
            r.id == "recurringsent5" ||
            r.id == "recurringsent6"
          ) {
            this.multiaxis.datasets.push({
              type: "bar",
              label: r.label,
              filter: r.id,
              yAxisID: "y2",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              data: [],
            });
            this.multiaxis.options.scales.xAxes = [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
              },
            ];
          } else {
            this.multiaxis.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: [],
            });
            this.multiaxisweek.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: [],
            });
            this.multiaxismonth.datasets.push({
              type: type,
              label: r.label,
              hidden: false,
              filter: r.id,
              borderColor: "RGBA(" + r.color + ",1)",
              backgroundColor: "RGBA(" + r.color + ",0.48)",
              pointBackgroundColor: "RGBA(" + r.color + ",1)",
              yAxisID: yaxis,
              data: [],
            });
          }
        }
      });
    },
    getDetails() {
      this.loadAgencyStats();
    },
    getMultiaxisMonth(type) {
      let stats = this.stats;

      if (stats.activity_by_date[type] === undefined) {
        return;
      }

      let meetings = stats.activity_by_date[type];
      let labels = stats.activity_by_date.labels;
      let newlabels = [];
      let indexof;
      let days = "";
      let day = "";
      let resmeetings = [];
      let reflabelmeeting = [];
      let datescols = [];

      labels.forEach((r, index) => {
        let days = r.split("/");
        day = new Date(days[0], days[1] - 1, days[2]);
        var refd = day.getFullYear() + "/" + days[1];
        if (reflabelmeeting.indexOf(refd) < 0) {
          reflabelmeeting.push(refd);
        }
        indexof = reflabelmeeting.indexOf(refd);
        if (newlabels[indexof] == undefined && meetings[index] !== undefined) {
          newlabels[indexof] = 0 + parseInt(meetings[index]);
        } else {
          newlabels[indexof] =
            parseInt(newlabels[indexof]) + parseInt(meetings[index]);
        }
      });

      newlabels.forEach((quantity, index) => {
        resmeetings.push(quantity);
      });
      this.multiaxismonth.labels = reflabelmeeting;
      this.multiaxis.datasets.forEach((r, index) => {
        if (r.filter == type) {
          this.multiaxismonth.datasets[index].data = resmeetings;
        }
      });
    },
    getGroupMonth() {
      this.groupedmeetignsmonth.labels = this.stats.activity_by_date.labels;

      this.groupedmeetignsmonth.datasets[0].label = "Planned %";
      this.groupedmeetignsmonth.datasets[1].label = "Canceled %";
      this.groupedmeetignsmonth.datasets[2].label = "Absent %";

      let stats = this.stats;
      let labels = stats.activity_by_date.labels;
      let newplanned = [];
      let newcanceled = [];
      let newabsent = [];
      let indexof;
      let days = "";
      let day = "";
      let planned = this.stats.activity_by_date["planned"];
      let canceled = this.stats.activity_by_date["canceled"];
      let absent = this.stats.activity_by_date["absent"];
      let reflabelmeeting = [];
      let datescols = [];

      if (labels !== undefined && labels.length > 0) {
        labels.forEach((r, index) => {
          let days = r.split("/");
          day = new Date(days[0], days[1] - 1, days[2]);
          var refd = day.getFullYear() + "/" + days[1];

          if (reflabelmeeting.indexOf(refd) < 0) {
            datescols.push(refd);
            reflabelmeeting.push(refd);
          }
          indexof = reflabelmeeting.indexOf(refd);

          if (
            newplanned[indexof] == undefined &&
            planned[index] !== undefined
          ) {
            newplanned[indexof] = 0 + parseInt(planned[index]);
          } else {
            newplanned[indexof] =
              parseInt(newplanned[indexof]) + parseInt(planned[index]);
          }
          if (
            newcanceled[indexof] == undefined &&
            canceled[index] !== undefined
          ) {
            newcanceled[indexof] = 0 + parseInt(canceled[index]);
          } else {
            newcanceled[indexof] =
              parseInt(newcanceled[indexof]) + parseInt(canceled[index]);
          }
          if (newabsent[indexof] == undefined && absent[index] !== undefined) {
            newabsent[indexof] = 0 + parseInt(absent[index]);
          } else {
            newabsent[indexof] =
              parseInt(newabsent[indexof]) + parseInt(absent[index]);
          }
        });
      }

      if (
        newplanned !== null &&
        newplanned !== undefined &&
        newplanned.length > 0
      ) {
        newplanned.forEach((quantity, index) => {
          planned.push(quantity);
        });
        newcanceled.forEach((quantity, index) => {
          canceled.push(quantity);
        });
        newabsent.forEach((quantity, index) => {
          absent.push(quantity);
        });
        this.groupedmeetignsmonth.labels = datescols;
        this.groupedmeetignsmonth.datasets[0].data = planned;
        this.groupedmeetignsmonth.datasets[1].data = canceled;
        this.groupedmeetignsmonth.datasets[2].data = absent;
      }
    },
    getGroupWeek() {
      this.groupedmeetignsweek.labels = this.stats.activity_by_date.labels;
      this.groupedmeetignsweek.datasets[0].label = "Planned %";
      this.groupedmeetignsweek.datasets[1].label = "Canceled %";
      this.groupedmeetignsweek.datasets[2].label = "Absent %";

      let stats = this.stats;
      let labels = stats.activity_by_date.labels;
      let newplanned = [];
      let newcanceled = [];
      let newabsent = [];
      let indexof;
      let days = "";
      let day = "";
      let planned = this.stats.activity_by_date["plannedcant"];
      let canceled = this.stats.activity_by_date["canceledcant"];
      let absent = this.stats.activity_by_date["absentcant"];
      let reflabelmeeting = [];
      let datescols = [];

      if (labels !== null && labels !== undefined && labels.length > 0) {
        labels.forEach((r, index) => {
          let days = r.split("/");
          let day = new Date(days[0], days[1] - 1, days[2]);

          var d = new Date(
            Date.UTC(day.getFullYear(), day.getMonth(), day.getDate())
          );
          var dayNum = d.getUTCDay() || 7;
          d.setUTCDate(d.getUTCDate() + 4 - dayNum);
          var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
          var week = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

          if (days[1] + "/" + days[2] == "01/01") {
            week = 1;
          }
          if (days[1] + "/" + days[2] == "01/02") {
            week = 1;
          }

          var refd = day.getFullYear() + " Week: " + week;

          if (reflabelmeeting.indexOf(refd) < 0) {
            datescols.push(refd);
            reflabelmeeting.push(refd);
          }
          indexof = reflabelmeeting.indexOf(refd);

          if (
            newplanned[indexof] == undefined &&
            planned[index] !== undefined
          ) {
            newplanned[indexof] = 0 + parseInt(planned[index]);
          } else {
            newplanned[indexof] =
              parseInt(newplanned[indexof]) + parseInt(planned[index]);
          }
          if (
            newcanceled[indexof] == undefined &&
            canceled[index] !== undefined
          ) {
            newcanceled[indexof] = 0 + parseInt(canceled[index]);
          } else {
            newcanceled[indexof] =
              parseInt(newcanceled[indexof]) + parseInt(canceled[index]);
          }
          if (newabsent[indexof] == undefined && absent[index] !== undefined) {
            newabsent[indexof] = 0 + parseInt(absent[index]);
          } else {
            newabsent[indexof] =
              parseInt(newabsent[indexof]) + parseInt(absent[index]);
          }
        });
      }

      let resplanned = [];
      let rescanceled = [];
      let resabsent = [];

      if (
        newplanned !== null &&
        newplanned !== undefined &&
        newplanned.length > 0
      ) {
        newplanned.forEach((quantity, index) => {
          var total = newcanceled[index] + newabsent[index] + newplanned[index];
          var it = quantity;
          var q = Math.round((it * 100) / total);
          resplanned.push(q);
          it = newcanceled[index];
          var q = Math.round((it * 100) / total);
          rescanceled.push(q);
          it = newabsent[index];
          var q = Math.round((it * 100) / total);
          resabsent.push(q);
        });

        this.groupedmeetignsweek.labels = datescols;
        this.groupedmeetignsweek.datasets[0].data = resplanned;
        this.groupedmeetignsweek.datasets[1].data = rescanceled;
        this.groupedmeetignsweek.datasets[2].data = resabsent;
      }
    },
    getMultiaxisWeek(type) {
      let stats = this.stats;
      if (stats.activity_by_date[type] === undefined) {
        return;
      }
      let meetings = stats.activity_by_date[type];
      let labels = stats.activity_by_date.labels;
      let newlabels = [];
      let indexof;
      let days = "";
      let day = "";
      let resmeetings = [];
      let reflabelmeeting = [];
      let datescols = [];

      if (labels !== null && labels !== undefined && labels.length > 0) {
        labels.forEach((r, index) => {
          let days = r.split("/");
          let day = new Date(days[0], days[1] - 1, days[2]);

          var d = new Date(
            Date.UTC(day.getFullYear(), day.getMonth(), day.getDate())
          );
          var dayNum = d.getUTCDay() || 7;
          d.setUTCDate(d.getUTCDate() + 4 - dayNum);
          var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
          var week = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

          if (days[1] + "/" + days[2] == "01/01") {
            week = 1;
          }
          if (days[1] + "/" + days[2] == "01/02") {
            week = 1;
          }

          var refd = day.getFullYear() + " Semana: " + week;

          if (reflabelmeeting.indexOf(refd) < 0) {
            datescols.push(day);
            reflabelmeeting.push(refd);
          }
          indexof = reflabelmeeting.indexOf(refd);
          if (
            newlabels[indexof] == undefined &&
            meetings[index] !== undefined
          ) {
            newlabels[indexof] = 0 + parseInt(meetings[index]);
          } else {
            newlabels[indexof] =
              parseInt(newlabels[indexof]) + parseInt(meetings[index]);
          }
        });
      }

      if (
        newlabels !== null &&
        newlabels !== undefined &&
        newlabels.length > 0
      ) {
        newlabels.forEach((quantity, index) => {
          resmeetings.push(quantity);
        });
        this.multiaxisweek.labels = datescols;

        this.multiaxis.datasets.forEach((r, index) => {
          if (r.filter == type) {
            this.multiaxisweek.datasets[index].data = resmeetings;
          }
        });
      }
    },
    getMultiaxis() {
      this.optselect.forEach((r, index) => {
        this.getMultiaxisMonth(r.id);
        this.getMultiaxisWeek(r.id);
      });
    },
    refreshgmail() {
      this.loadinggmail = true;
      adminService.getGmailImports().then((result) => {
        this.gmaillist = result;
        this.keygmail++;
        this.loadinggmail = false;
      });
    },
    validarDate() {
      let startDate = new Date(this.range.startDate);
      let endDate = new Date(this.range.endDate);
      if (startDate.getTime() > endDate.getTime()) {
        return true;
      } else {
        return false;
      }
    },
    loadRangeStats() {
      if (
        this.filters.indexOf("recurringsent") >= 0 &&
        this.filters.indexOf("recurringsent2") < 0
      ) {
        this.filters.push("recurringsent2");
        this.filters.push("recurringsent3");
        this.filters.push("recurringsent4");
        this.filters.push("recurringsent5");
        this.filters.push("recurringsent6");
        this.optselect.push(this.options["recurringsent2"]);
        this.optselect.push(this.options["recurringsent3"]);
        this.optselect.push(this.options["recurringsent4"]);
        this.optselect.push(this.options["recurringsent5"]);
        this.optselect.push(this.options["recurringsent6"]);
      }

      this.multiaxis.datasets = [];
      this.multiaxisweek.datasets = [];
      this.multiaxismonth.datasets = [];
      this.loadMultiaxis();
      this.meetings_details = [];
      this.openlist = false;
      this.openchart = true;
      if (this.validarDate() === true) {
        this.$swal({
          type: "warning",
          title: "Error!",
          text: "Start date should be less than end date. ",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Close",
        });
      } else {
        this.getCampaignStatsByIdAndRange({
          id: this.selCampaignId != undefined ? this.selCampaignId : 0,
          startDate: this.range.startDate,
          endDate: this.range.endDate,
          client: this.client,
          filters: this.filters,
        });
      }
    },
    loadStatsData() {
      if (!this.loadingStats) {
        this.multiaxis.labels = this.stats.activity_by_date.labels;
        this.multiaxis.datasets.forEach((r, index) => {
          this.multiaxis.datasets[index].data =
            this.stats.activity_by_date[this.multiaxis.datasets[index].filter];
        });

        this.getMultiaxis();

        this.groupedmeetigns.labels = this.stats.activity_by_date.labels;
        this.groupedmeetigns.datasets[0].label = "Planned %";
        this.groupedmeetigns.datasets[1].label = "Canceled %";
        this.groupedmeetigns.datasets[2].label = "Absent %";
        this.groupedmeetigns.datasets[0].data =
          this.stats.activity_by_date["planned"];
        this.groupedmeetigns.datasets[1].data =
          this.stats.activity_by_date["canceled"];
        this.groupedmeetigns.datasets[2].data =
          this.stats.activity_by_date["absent"];

        this.getGroupWeek();
        this.getGroupMonth();
      }
    },
    getMoreTeam() {
      let actualcant = this.teamgroups.length;
      this.groups.forEach((r, index) => {
        if (index >= actualcant && index < actualcant + 10) {
          this.cantgroups++;
          this.teamgroups.push(r);
        }
      });
    },
    myTeamList() {
      if (this.clientId == null && this.hasPermissions('adminClients')) {
        monitorService.getClients().then((result) => {
          this.groups = result;
          result.forEach((r, index) => {
            if (index < 10) {
              this.cantgroups++;
              this.teamgroups.push(r);
            }
          });
        });
      } else {
        this.client = this.clientId;
        this.groups.push({ id: this.clientId, name: "yooo" });
        this.changeThisTab(1);
      }
    },
    refreshlinkedin() {
      this.loadinglinkedin = true;
      adminService.getLinkedinImports().then((result) => {
        this.linkedinlist = result;
        this.keylinkedin++;
        this.loadinglinkedin = false;
      });
    },
    goToOpportunity(link_id) {
      window.open("/opportunities/" + link_id, "_blank");
    },
  },
};
</script>
<style>
.scrollable {
  height: 50vh;
  overflow: scroll !important;
  width: 100% !important;
}
.vm--modal {
  overflow-y: scroll !important;
}
</style>
